import React from 'react'
import styled from 'styled-components'

import Button from '@/components/button'
import {Text} from '@/components/text'
import {tokens, colors, radii} from '@/theme'
import mq from '@/utils/media-query'

import type {BackgroundColor} from '@/utils/is-valid-background-color'

export interface Props {
    labelText: string
    labelColor: BackgroundColor
    heading: string
    excerpt: string
    CTA?: React.ComponentType<any>
}

export const Panel = ({labelText, labelColor, heading, excerpt, CTA}: Props) => (
    <Wrapper>
        <CopyWrapper>
            <Label $variant="label-base" $backgroundColor={labelColor}>
                {labelText}
            </Label>
            <Text $variant="heading-base">{heading}</Text>
            <Text $variant="paragraph-base">{excerpt}</Text>
        </CopyWrapper>
        {CTA && <Button as={CTA} $variant="outline" />}
    </Wrapper>
)

export const Wrapper = styled.div`
    background: ${colors.background.muted};
    border-radius: ${radii.arc20};
    padding: ${tokens.spacing20};
    display: flex;
    flex-direction: column;
    gap: ${tokens.spacing8};

    ${mq.min('sm')} {
        flex-direction: row;
        gap: 80px;
        align-items: flex-end;
        padding: ${tokens.spacing40};
    }
`

interface LabelProps {
    $backgroundColor?: Props['labelColor']
}

const Label = styled(Text)<LabelProps>`
    background: ${({$backgroundColor}) => colors.background[$backgroundColor || 'pink']};
    padding: ${tokens.spacing4} ${tokens.spacing8};
    align-self: flex-start;
    border-radius: ${radii.arc4};
`

const CopyWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${tokens.spacing8};
    flex: 1;
    ${mq.max('sm')} {
        margin-bottom: ${tokens.spacing32};
    }
`
